<template>
  <div>
    <!-- alert container -->
    <label for="input" class="block text-sm py-1 font-semibold text-argus-forest-800">
      {{ field.label }}<span v-if="field.required" class="text-argus-error text-sm">*</span>
    </label>
    <textarea
      name="input"
      rows="3"
      class="w-full px-3 py-2 text-sm border-1 border-argus-border rounded-lg resize-none placeholder-text-argus-forest-600 text-argus-forest-600 placeholder-opacity-50 focus:border-argus-border"
      :placeholder="field.placeholder"
      :value="value"
      :required="field.required"
      ref="input"
      :disabled="disabled"
      data-private
      @input="updateValue"
    />
    <template v-if="field.error">
      <p class="text-argus-error text-sm py-1">{{ errorMessage }}</p>
    </template>
    <template v-else-if="field.help_text">
      <p class="text-argus-forest-600 text-sm py-1">{{ field.help_text }}</p>
    </template>
  </div>
</template>
<script>
export default {
  emits: ['update'],
  props: {
    field: Object,
  },
  data() {
    return {
      errorMessage: '',
      touched: false,
      value: '',
      disabled: false,
    }
  },
  mounted() {
    this.value = this.field.value
  },
  computed: {
    isValid() {
      if (this.field.required && !this.field.value) {
        return false
      }
      return true
    },
  },
  methods: {
    updateHelpText(ev) {
      // eslint-disable-next-line vue/no-mutating-props
      this.field.help_text = ev.target.value
    },
    updateValue(ev) {
      this.touched = true
      this.$emit('update', ev.target.value)
    },
    validateField() {
      if (!this.isValid) {
        if (this.field.required && !this.field.value) {
          this.errorMessage = 'This field is required.'
        }
      } else {
        this.errorMessage = ''
      }
    },
  },
}
</script>
<style scoped>
textarea:focus {
  outline: none;
  box-shadow: none;
}
</style>
